import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import instance from "../instance"; // Your Axios instance

// Fetch Projects
export const useFetchProjects = (filters) => {
  const fetchProjects = async () => {
    const { data } = await instance.get(`/api/projects?pageNumber=${filters.pageNumber||""}&pageSize=${filters.pageSize||""}&search=${filters?.search ||""}&orgId=${filters.orgId||""}`); // Your API endpoint
    return data;
  };

  const query = useQuery({
    queryKey: ['fetch projects', filters],
    queryFn: fetchProjects,
  });

  return query;
};

// Add Project
export const useAddProject = () => {
  const queryClient = useQueryClient();
  const addProjectMutation = useMutation(async (newProject) => {
    const { data } = await instance.post('/api/projects', newProject); // Your API endpoint
    return data;
  }, {
    onSuccess: () => {
      queryClient.invalidateQueries(['fetch projects']);
    },
  });

  return addProjectMutation;
};

// Update Project
export const useUpdateProject = () => {
  const queryClient = useQueryClient();
  const updateProjectMutation = useMutation(async (updatedProject) => {
    const { data } = await instance.put(`/api/projects/${updatedProject.id}`, updatedProject); // Include ID
    return data;
  }, {
    onSuccess: () => {
      queryClient.invalidateQueries(['fetch projects']);
    },
  });

  return updateProjectMutation;
};

// Delete Project
export const useDeleteProject = () => {
  const queryClient = useQueryClient();
  const deleteProjectMutation = useMutation(async (projectId) => {
    await instance.delete(`/api/projects/${projectId}`); // Include ID
  }, {
    onSuccess: () => {
      queryClient.invalidateQueries(['fetch projects']);
    },
  });

  return deleteProjectMutation;
};
